import cn from 'classnames';
import moment from 'moment';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import PostingsApi from '../../../../API/shipment/postings-api';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { NavLink } from '../../../../components/Basic/Elements';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { TextGrey } from '../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import PackagingMethodSelect from '../../../../components/Providers/Inputs/PackagingMethodSelect';
import { MAP_SKLAD_SHORT, TO_POSING, TO_SHIPMENT, TYPE_BUTTONS } from '../../../../constans';
import { formFullDate, getDateMonth } from '../../../../utils';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';

const STATE = {
  not_collected: { text: 'Не обработан', color: '' },
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Ожидает упаковки', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
  sorted: { text: 'Отсортирован', color: 'rgba(239,104,193,0.75)' },
};

const PostingLine = ({
  mode,
  shipmentMode = true,
  order = {},
  isAdmin = false,
  scan = (_) => _,
  shipment = {},
  map = {},
  postingsPrint = {},
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  is_owner,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const packageMethods = useSelector((store) => store.packaging);

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const onChangePosting = async (id, field, value) => {
    await PostingsApi.changePosting({ data: { postingNumber: id, field, value } }).then((r) => {
      //dispatch(changeShipmentPosting(r.posting));
    });
  };

  let data = map[order.offer_id]
  const scan_time_first = order.scan_time?.pick ? formFullDate(order.scan_time?.pick) : null;
  const scan_time_order = order.scan_time?.packager ? formFullDate(order.scan_time?.packager) : null;
  const sort_time_order = order.scan_time?.sort ? formFullDate(order.scan_time?.sort) : null;

  return (
    mode === 'FBS' ?
      <TableLine key={order.number}>
        <TableCell width={WIDTH_POSTING[0]}>
          {isAdmin ? (
            <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
              {order.posting_number}
            </Link>
          ) : (
            <>{order.posting_number} </>
          )}{' '}
          {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
          <Row style={{ width: '100%' }}>
            {order.market === 'wb' && <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
          </Row>
        </TableCell>
        {is_owner && (
          <TableCell width={WIDTH_POSTING[12]} center={true}>
            {is_owner ? (
              <NavLink
                to={TO_SHIPMENT(order.shipment_id)}
                target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '18px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            ) : (
              <div className={styles.scan_time} style={{ fontSize: '18px' }}>
                {getDateMonth(order.dates.shipment_date)}
              </div>
            )}
          </TableCell>
        )}
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            {order.products.map((p, k) => {
              const data = map[p.offer_id] || {};
              const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
              const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
              return (
                <div key={k} className={styles.div_line_images}>
                  <div className={styles.wrapper}>
                    <img
                      onClick={() => openImageViewer(img)}
                      className={styles.preview}
                      src={img.length > 0 ? img[0] : undefined}
                    />
                  </div>
                  <Column>
                    <div className={styles.name}>
                      {`${p.ordered_quantity} x ${p.name}  `}
                      <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                        {p.offer_id}
                      </div>
                    </div>
                    {scan_time && (
                      <div className={styles.scan_time}>
                        {scan_time} {p.scan_user && `(${p.scan_user})`}
                      </div>
                    )}
                  </Column>
                </div>
              );
            })}
          </Column>
        </TableCell>

        <TableCell width={WIDTH_POSTING[8]} center={true}>
          <Column center>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={k} className={styles.div_line}>
                <div className={styles.num}> {p.common_quantity || 0}</div>
              </Row>
            ))}
          </Column>
        </TableCell>

        {is_owner && (
          <>
            {' '}
            <TableCell width={WIDTH_POSTING[4]} center={true}>
              <div
                className={cn(
                  styles.status,
                  (order.state === 'not_collected' || order.state === 'not_started') && styles.process,
                  order.state === 'collected' && styles.collected,
                  order.state === 'packed' && styles.packed,
                  order.state === 'sorted' && styles.sorted,
                )}
              >
                {STATE[order.state].text}
              </div>
            </TableCell>
            <TableCell width={WIDTH_POSTING[12]} center={true}>
              <div>{MAP_SKLAD_SHORT[order.sklad]}</div>
            </TableCell>
          </>
        )}
        <TableCell width={WIDTH_POSTING[3]} center>
          <Row>
            <PackagingMethodSelect
              method={order.packaging_method}
              // disabled={!is_owner}
              disabled={true}
              onSelect={(v) => onChangePosting(order.posting_number, 'packaging_method', v._id)}
            />
            <Row className={styles.num_pay}> {order.scan_pay?.packager}</Row>
          </Row>
        </TableCell>

        <TableCell width={WIDTH_POSTING[4]} center>
          <div>
            <div className={styles.user_name} style={{ fontWeight: 500 }}>
              {order.scan_user?.pick && `${order.scan_user?.pick}`}
            </div>
            <div className={styles.scan_time}>{scan_time_first}</div>
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center>
          <div>
            <div className={styles.user_name} style={{ fontWeight: 500 }}>
              {order.scan_user?.packager && `${order.scan_user?.packager}`}
            </div>
            <div className={styles.scan_time}> {scan_time_order}</div>
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center>
          <div>
            <div className={styles.user_name} style={{ fontWeight: 500 }}>
              {order.scan_user?.sort && `${order.scan_user?.sort}`}
            </div>
            <div className={styles.scan_time}> {sort_time_order}</div>
          </div>
        </TableCell>
        {is_owner && (
          <>
            <TableCell width={WIDTH_POSTING[4]}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={k} className={styles.div_line}>
                    <ProviderList selectProviderId={(map[p.offer_id] || {}).provider_id} disabled={true} />
                  </div>
                ))}
              </Column>
            </TableCell>
            <Button type={TYPE_BUTTONS.BLUE} onClick={() => scan(4, order.posting_barcodes[0])}>
              scan package
            </Button>
          </>
        )}

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
      :
      <TableLine key={order._id}>
        <TableCell center width={WIDTH_POSTING[12]}>
          <Column style={{ alignItems: 'center' }}>
            <TextGrey style={{ fontSize: '18px', marginBottom: '3px', color: '#6c11c9' }}>{order.shop}</TextGrey>
            <div style={{ fontSize: '12px', color: '#00000098' }}>{order.last_package_pick_date ? moment(order.last_package_pick_date).format('DD.MM HH:mm') : ''}</div>
          </Column>
        </TableCell>
        {/* <TableCell width={WIDTH_POSTING[0]}>
          {isAdmin ? (
            <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
              {order.posting_number}
            </Link>
          ) : (
            <>{order.posting_number} </>
          )}{' '}
          {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
          <Row style={{ width: '100%' }}>
            {order.market === 'wb' && <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
          </Row>
        </TableCell> */}
        {/* {is_owner && (
          <TableCell width={WIDTH_POSTING[12]} center={true}>
            {is_owner ? (
              <NavLink
                to={TO_SHIPMENT(order.shipment_id)}
                target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '18px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            ) : (
              <div className={styles.scan_time} style={{ fontSize: '18px' }}>
                {getDateMonth(order.dates.shipment_date)}
              </div>
            )}
          </TableCell>
        )} */}
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            <div className={styles.div_line_images}>
              <div className={styles.wrapper}>
                <img
                  onClick={() => openImageViewer(data?.images)}
                  className={styles.preview}
                  src={data?.images ? data?.images?.[0] : undefined}
                />
              </div>
              <Column>
                <div className={styles.name}>
                  {`${order.ordered_quantity} x ${order.name}  `}
                  <div className={cn(styles.offer_id, order.status === 'Нет в наличии' && styles.red_text)}>
                    {order.offer_id}
                  </div>
                </div>
                {/* {order.scan_time && (
                  <div className={styles.scan_time}>
                    {scan_time} {p.scan_user && `(${p.scan_user})`}
                  </div>
                )} */}
              </Column>
            </div>
          </Column>
        </TableCell>


        {/* <TableCell width={WIDTH_POSTING[0]} center={true}>
          <Column style={{ alignItems: 'center' }}>
            <div style={{ fontSize: '16px' }}>{order.last_package_pick_date ? moment(order.last_package_pick_date).format('HH:mm') : ''}</div>
          </Column>
        </TableCell> */}
        <TableCell width={WIDTH_POSTING[0]} center={true}>
          <Column style={{ alignItems: 'center' }}>
            <Row className={styles.div_line}>
              <div className={styles.num}>{order.packager?.count || 0} / {order.processed_quantity || 0}
                {/* / {order.ordered_quantity || 0} */}
              </div>
            </Row>
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[8]} center={true}>
          <Column style={{ alignItems: 'center' }}>
            <div className={styles.num}>{data.quantity}</div>
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[3]} center>
          <Row>
            <PackagingMethodSelect
              method={packageMethods.find(m => m._id === data.packaging_method_id)?.method}
              disabled={true}
              onSelect={(v) => onChangePosting(order.posting_number, 'packaging_method', v._id)}
            />
            <Row className={styles.num_pay}> {order?.scan_pay?.packager}</Row>
          </Row>
        </TableCell>
        <TableCell width={WIDTH_POSTING[0]} center={true}>
          <Column style={{ alignItems: 'center' }}>
            <div style={{ fontWeight: 'bold', color: '#000000a5' }}>{order.packager?.name}</div>
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[12]} center={true}>
          <Column style={{ alignItems: 'center' }}>
            <div style={{ fontWeight: 'bold', color: '#000000a5' }}>
              {order.packager?.first_time && moment(order.last_package_pick_date).diff(moment(order.packager?.first_time), 'minutes') + ' мин.'}
              {/* {order.packager.first_time} */}
              {/* {order.last_package_pick_date} */}
            </div>
          </Column>
        </TableCell>
        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
  );
};

export default PostingLine;
